export const filterSearch = (query: string, arr: any[]) => {
  if (!query) {
    return arr;
  }

  return arr?.filter((item) => {
    const title = item?.title?.toLowerCase() ?? item?.name?.toLowerCase();
    return title?.includes(query?.toLowerCase());
  });
};
